export default function LevelControlController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.ECAT;

  // Attach Event Handlers
  vm.handleSelectedChange = _handleSelectedChange;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    return userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
  }

  function _handleSelectedChange() {
    $rootScope.$broadcast('refreshComponentLevelInformation', { componentLevelId: vm.componentLevelId });
  }
}

LevelControlController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds'
];
